import { types, actions } from './requests'
export const DELETEPRODUCT_TYPES = {
    ...types('DELETEPRODUCT'),
}
export const DELETEPRODUCT_ACTIONS = {
    ...actions('DELETEPRODUCT'),
}
